import { useSelector } from 'react-redux';

import { selectUser } from '@app/redux';

import { ProductInstanceStatus } from '@mfe/shared/schema-types';

import { GetAccountInfoPayload, Scalars } from '@viasat/res-apps-lib/build/types/mv';

type GetAccountInfoPayloadWithUsername = GetAccountInfoPayload & {
  username: Scalars['String'];
};

export type UseAccountInfoPayload = Pick<GetAccountInfoPayloadWithUsername, 'accountStatus' | 'accountReference'> & {
  isAccountActive: boolean;
  isAccountPreInstall: boolean;
  isAccountDisconnected: boolean;
  isAccountSuspended: boolean;
};
const accountActive = (accountStatus: ProductInstanceStatus): boolean =>
  [ProductInstanceStatus.Active].includes(accountStatus);

const accountPreInstall = (accountStatus: ProductInstanceStatus): boolean =>
  [ProductInstanceStatus.Preinstall, ProductInstanceStatus.Canceled].includes(accountStatus);

const accountDisconnected = (accountStatus: ProductInstanceStatus): boolean =>
  [ProductInstanceStatus.Deactivated].includes(accountStatus);

// We assume that the user's account is suspended if their account is in another state
export const accountSuspended = (accountStatus: ProductInstanceStatus): boolean =>
  !accountActive(accountStatus) && !accountPreInstall(accountStatus) && !accountDisconnected(accountStatus);

export function useAccountStatus(): UseAccountInfoPayload {
  const { user } = useSelector(selectUser);
  const productInstanceStatus = user.productInstanceStatus as ProductInstanceStatus;

  return {
    accountStatus: productInstanceStatus,
    accountReference: user.accountNumber,
    isAccountActive: accountActive(productInstanceStatus),
    isAccountPreInstall: accountPreInstall(productInstanceStatus),
    isAccountDisconnected: accountDisconnected(productInstanceStatus),
    isAccountSuspended: accountSuspended(productInstanceStatus),
  };
}
